import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
import {
    Router, ActivatedRoute, Event as RouterEvent, NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError
} from '@angular/router';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
import { _ } from 'underscore';
@Injectable()
export class AuthenticationService {
    loggedIn: boolean;
    user: any;
    token: any;
    loading: boolean;
    permissions: any = [];
    constructor(private http: Http, private router: Router, private config: AppConfig, private _jsonp: Jsonp) {
        if (localStorage.getItem("token")) {
            this.setLoading(false);
            this.token = localStorage.getItem("token");
            const storeUser = localStorage.getItem('user');
            this.user = storeUser && JSON.parse(storeUser);
            this.permissions = localStorage.getItem('permissions') || [];
            if (this.user.is_temp_password_set == false) {
                this.setLoggedIn(true);
            }
            if (this.user && this.user.role_id === 1) {
                let isPasswordReset = localStorage.getItem("isPasswordReset");
                if (isPasswordReset == undefined  || isPasswordReset != 'true' || !isPasswordReset) {
                    this.logout();
                }
            }
        } else {
            this.setLoggedIn(false);
            this.setLoading(false);
        }
    }
    loggedIn$ = new BehaviorSubject<boolean>(this.loggedIn);
    permissions$ = new BehaviorSubject<any>(this.permissions);
    loading$ = new BehaviorSubject<boolean>(this.loading);
    user$ = new BehaviorSubject<any>(this.user);
    getLoading(): Observable<any> {
        return this.loading$.asObservable();
    }
    getLoggedIn(): Observable<any> {
        return this.loggedIn$.asObservable();
    }
    getUser(): Observable<any> {
        return this.user$.asObservable();
    }
    login(user: any) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({
            headers: headers
        });
        return this.http.post(this.config.apiAuthUrl + 'user/login', user, this.setHeaders())
            .map((response: Response) => {
                let user = response.json();
                console.log(user);
                localStorage.setItem('token', user.admintoken);
                localStorage.setItem('user', JSON.stringify(user.user)); // to fetch the user details on refresh
                localStorage.setItem('permissions', JSON.stringify(_.pluck(user.user.permissions, 'name')))
                this.token = localStorage.getItem("token");
                this.user = user.user;
                this.permissions = _.pluck(user.user.permissions, 'name');
                // if(this.user.is_temp_password_set == false){
                //     this.setLoggedIn(true);
                // }
                return user;
            });
    }
    logout() {
        //   this.setLoggedIn(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('permissions');
        localStorage.removeItem('isPasswordReset');
        localStorage.clear();
        //   this.router.navigate(['login']);
        window.location.reload();
    }
    setLoggedIn(value: boolean) {
        // Update login status subject
        console.log('set loggedIn >>>' + value);
        this.loggedIn$.next(value);
        this.loggedIn = value;
    }
    setPermissions(value: any) {
        this.permissions = _.pluck(value, 'name');
        console.log(this.permissions);
        this.permissions$.next(this.permissions);
        localStorage.setItem('permissions', this.permissions);
    }
    setLoading(value: boolean) {

        // Update login status subject
        this.loading$.next(value);
        this.loading = value;
    }
    setUser(value: any) {
        console.log('Called >>>' + value);
        this.user$.next(value);
        this.user = value;
        localStorage.setItem('user', JSON.stringify(value));
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/authentication.service.ts